import React, { useEffect } from 'react'

function ScrollToTop({ children }) {

    useEffect(() => {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        })
    }, [])


    return (
        <div className='w-full relative'>{children}</div>
    )
}

export default ScrollToTop